(function () {
  'use strict';

  /* Style à injecter */
  var CSS = [
    /* ── Prix orange ── */
    '.price .money, .price__current .money, .price-item .money, [class*="price"] .money {',
    '  color: #E25D0F !important;',
    '  -webkit-text-fill-color: #E25D0F !important;',
    '  font-family: "Montserrat",sans-serif !important;',
    '  font-size: 26px !important;',
    '  font-weight: 800 !important;',
    '}',

    /* ── Onglets email : classes connues ── */
    '.gift-card-form-option__button-label {',
    '  font-family: "Montserrat",sans-serif !important;',
    '  font-size: 12px !important;',
    '  font-weight: 700 !important;',
    '  letter-spacing: .04em !important;',
    '  padding: 10px 14px !important;',
    '  border-radius: 9px !important;',
    '  border: 2px solid transparent !important;',
    '  background-image: linear-gradient(rgba(255,255,255,0.96),rgba(255,255,255,0.96)), linear-gradient(90deg,#0B5A8F,#E25D0F) !important;',
    '  background-origin: border-box !important;',
    '  background-clip: padding-box, border-box !important;',
    '  color: #1a1a1a !important;',
    '  -webkit-text-fill-color: #1a1a1a !important;',
    '  cursor: pointer !important;',
    '  background-color: transparent !important;',
    '}',
    '.gift-card-form-option__button-label:has(:checked) {',
    '  background-image: linear-gradient(90deg,#0B5A8F,#E25D0F), linear-gradient(90deg,#0B5A8F,#E25D0F) !important;',
    '  color: #fff !important;',
    '  -webkit-text-fill-color: #fff !important;',
    '}',

    /* ── Champs ── */
    '.recipient-fields__input {',
    '  font-family: "Montserrat",sans-serif !important;',
    '  font-size: 13px !important;',
    '  border: 1.5px solid rgba(11,90,143,0.25) !important;',
    '  border-radius: 10px !important;',
    '  background: rgba(255,255,255,0.96) !important;',
    '  color: #1a1a1a !important;',
    '  -webkit-text-fill-color: #1a1a1a !important;',
    '}',
    '.recipient-fields__input:focus {',
    '  border-color: #0B5A8F !important;',
    '  box-shadow: 0 0 0 3px rgba(11,90,143,0.10) !important;',
    '}'
  ].join('\n');

  function injectStyle() {
    if (document.getElementById('dmx-gift-style')) return;
    var s = document.createElement('style');
    s.id = 'dmx-gift-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* Style appliqué sur chaque bouton montant via JS inline */
  var BTN_NORMAL = [
    'font-family:"Montserrat",sans-serif',
    'font-size:12px',
    'font-weight:700',
    'letter-spacing:.05em',
    'padding:8px 20px',
    'border-radius:9px',
    'border:2px solid transparent',
    'background-image:linear-gradient(rgba(255,255,255,0.96),rgba(255,255,255,0.96)),linear-gradient(90deg,#0B5A8F,#E25D0F)',
    'background-origin:border-box',
    'background-clip:padding-box,border-box',
    'color:#1a1a1a',
    '-webkit-text-fill-color:#1a1a1a',
    'cursor:pointer',
    'display:inline-flex',
    'align-items:center',
    'justify-content:center',
    'transition:all .18s',
    'min-width:64px',
    'text-align:center'
  ].join(';');

  var BTN_ACTIVE = [
    'font-family:"Montserrat",sans-serif',
    'font-size:12px',
    'font-weight:700',
    'letter-spacing:.05em',
    'padding:8px 20px',
    'border-radius:9px',
    'border:2px solid transparent',
    'background-image:linear-gradient(90deg,#0B5A8F,#E25D0F),linear-gradient(90deg,#0B5A8F,#E25D0F)',
    'background-origin:border-box',
    'background-clip:padding-box,border-box',
    'color:#fff',
    '-webkit-text-fill-color:#fff',
    'cursor:pointer',
    'display:inline-flex',
    'align-items:center',
    'justify-content:center',
    'transition:all .18s',
    'min-width:64px',
    'text-align:center'
  ].join(';');

  function styleDenominationButtons() {
    /* Chercher tous les éléments qui ressemblent à des boutons montants :
       - boutons radio + label dans un variant picker
       - boutons avec texte type "25 €", "50 €" etc.
       - tout bouton/label dans [class*="denomination"] ou [class*="variant"] */
    var selectors = [
      '.variant-picker__button',
      '[class*="denomination"] button',
      '[class*="denomination"] label',
      '[class*="denomination"] a',
      '.gift-card-denominations button',
      '.gift-card-denominations label',
      '[data-denomination]',
      'fieldset [class*="variant"] button',
      'fieldset [class*="variant"] label'
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.dataset.dmxStyled) return;
        el.dataset.dmxStyled = '1';

        /* Déterminer si actif */
        var isActive =
          el.getAttribute('aria-pressed') === 'true' ||
          el.classList.contains('active') ||
          el.classList.contains('is-active') ||
          el.classList.contains('selected') ||
          (el.querySelector && el.querySelector('input:checked')) !== null;

        el.setAttribute('style', isActive ? BTN_ACTIVE : BTN_NORMAL);

        /* Hover */
        el.addEventListener('mouseenter', function () {
          if (!this._dmxActive) {
            this.style.cssText = BTN_NORMAL + ';background-image:linear-gradient(rgba(11,90,143,0.08),rgba(11,90,143,0.08)),linear-gradient(90deg,#0B5A8F,#E25D0F)';
          }
        });
        el.addEventListener('mouseleave', function () {
          if (!this._dmxActive) {
            this.setAttribute('style', BTN_NORMAL);
          }
        });
      });
    });

    /* Gérer l'état actif via mutation sur les aria-pressed */
    document.querySelectorAll('.variant-picker__button, [data-denomination]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* Reset tous les frères */
        var parent = btn.closest('fieldset, [class*="picker"], [class*="denomination"]');
        if (parent) {
          parent.querySelectorAll('[data-dmx-styled]').forEach(function (b) {
            b._dmxActive = false;
            b.setAttribute('style', BTN_NORMAL);
          });
        }
        btn._dmxActive = true;
        btn.setAttribute('style', BTN_ACTIVE);
      });
    });
  }

  /* Observer pour attraper les éléments chargés en async */
  function observe() {
    injectStyle();
    styleDenominationButtons();

    var observer = new MutationObserver(function () {
      styleDenominationButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(styleDenominationButtons, 500);
    setTimeout(styleDenominationButtons, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

})();
